"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

var _index = _interopRequireDefault(require("../style/index"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Input = _createStyled["default"].input(_templateObject()),
    Label = _createStyled["default"].label(_templateObject2()),
    Div = _createStyled["default"].div(_templateObject3());

function template() {
  var _this = this;

  var styles = this.compileStyled(_index["default"]),
      selected = this._getSelected(),
      _this$props = this.props,
      onChange = _this$props.onChange,
      attribute = _this$props.attribute,
      label = _this$props.label,
      className = _this$props.className,
      _this$state = this.state,
      id = _this$state.id,
      position = _this$state.position,
      list = _this$state.list;

  var input = null,
      items = null,
      labelContent = null,
      mask = null;

  if (list && list.length) {
    items = [];
    var itemContent;
    list.forEach(function (item, i) {
      var isReactComponent = _react["default"].isValidElement(item.name),
          stringName = isReactComponent ? _l10n["default"].translate(item.stringName) : _l10n["default"].translate(item.name);

      items.push(_react["default"].createElement(Input, {
        id: id + i,
        type: "radio",
        styles: styles.field,
        checked: item.id === (selected && selected.id),
        value: item.id,
        name: id,
        onChange: _this._onChange,
        key: "item-".concat(i),
        "data-qa-node": attribute + '-option',
        "data-qa-value": stringName
      }));

      if (isReactComponent) {
        itemContent = item.name;
      } else {
        itemContent = stringName;
      }

      items.push(_react["default"].createElement(Label, {
        styles: styles.fieldLabel,
        htmlFor: id + i,
        key: "label-".concat(i),
        ref: _this._labelRef,
        "data-id": item.id,
        title: stringName
      }, itemContent));
    });

    if (label) {
      labelContent = _react["default"].createElement(Div, {
        styles: styles.label
      }, label);
    }

    if (selected && selected.id) {
      var selectedContent;

      var isReactComponent = _react["default"].isValidElement(selected.name),
          stringName = isReactComponent ? _l10n["default"].translate(selected.stringName) : _l10n["default"].translate(selected.name);

      if (isReactComponent) {
        selectedContent = selected.name;
      } else {
        selectedContent = stringName;
      }

      mask = _react["default"].createElement(Div, {
        styles: styles.mask,
        style: position,
        title: stringName,
        "data-qa-node": attribute,
        "data-qa-value": stringName
      }, selectedContent);
    }

    input = _react["default"].createElement(Div, {
      styles: styles.input
    }, _react["default"].createElement(Div, {
      styles: styles.wrapper,
      ref: this._listRef
    }, mask, items));
  }

  return _react["default"].createElement(Div, {
    styles: styles.root,
    className: className
  }, labelContent, input);
}